// Auto-generated from translation.csv; do not edit manually
export const zhCN = {
  "accountGuide": {
    "content": "打开任意一款Touka旗下游戏,前往游戏内设置界面,绑定你的邮箱,即可享受特价商品优惠!",
    "title": "如何创建账号?"
  },
  "bottomNav": {
    "home": "主页",
    "myOrders": "我的订单"
  },
  "common": {
    "loading": "加载中...",
    "noData": "暂无数据",
    "server": "服务器"
  },
  "auth": {
    "tokenExpired": "登录已过期，请重新登录"
  },
  "errors": {
    "900400": "内部参数错误",
    "900401": "登录认证失败",
    "900402": "登录认证过期",
    "1000000": "系统错误，请稍后重试",
    "1000001": "系统参数错误，请稍后重试",
    "1000002": "验证码ID或验证码不能为空",
    "1000003": "邮箱格式无效",
    "1000004": "验证码无效",
    "1000005": "验证码已发送，请等待5分钟后重试",
    "1000006": "验证码发送次数已达上限，请明天再试",
    "1000007": "邮箱不能为空",
    "1000008": "验证码不能为空",
    "1000009": "验证码无效",
    "1000010": "获取登录令牌失败",
    "1000011": "商品已下架，请选择其他商品",
    "1000012": "商品购买数量已超过限购数量，请选择其他商品",
    "1000013": "商品已下架",
    "1000014": "支付方式未启用",
    "1000015": "您的账号不支持购买商品，请联系客服",
    "1000016": "创建订单失败，请重试",
    "1000017": "订单不可取消"
  },
  "footer": {
    "language": "中文(简体)",
    "privacyPolicy": "隐私政策",
    "refundPolicy": "退款政策",
    "termsOfService": "服务条款",
    "userSupport": "用户支持",
    "downloadNow": "立即下载！"
  },
  "header": {
    "characterName": "角色名称",
    "gameServer": "游戏区组",
    "selectGameServer": "请选择游戏区组",
    "greeting": "您好",
    "loginPrompt": "请点击登录",
    "switchServer": "切换",
    "title": "游戏充值平台",
    "logout": "退出登录"
  },
  "games": {
    "bamBamSquad": "BamBamSquad",
    "oopsieCroco": "哎呀！克洛克"
  },
  "history": {
    "backToGameZone": "返回专区",
    "allGames": "全部游戏",
    "empty": "暂无订单",
    "filter": {
      "all": "全部",
      "closed": "已关闭",
      "completed": "已完成",
      "inProgress": "进行中",
      "pendingDelivery": "待发货"
    },
    "orderTime": "下单时间:",
    "pendingAutoCancelPrefix": "订单将在",
    "pendingAutoCancelSuffix": "后取消",
    "cancelOrder": "取消订单",
    "payOrder": "支付",
    "cancelOrderConfirmTitle": "确认取消订单？",
    "cancelOrderConfirmPrimary": "确认取消",
    "cancelOrderDismiss": "暂不取消",
    "cancelOrderSuccess": "订单已取消",
    "cancelOrderFailed": "取消订单失败，请稍后重试",
    "fetchOrderFailed": "获取订单信息失败",
    "createOrderFailed": "创建订单失败",
    "payConfigError": "支付配置错误，请联系客服",
    "payRetryFailed": "重新支付失败，请重试",
    "status": {
      "cancelled": "已取消",
      "completed": "交易完成",
      "paid": "已支付",
      "pending": "待支付",
      "shipped": "已发货"
    }
  },
  "home": {
    "selectGame": "选择您要充值的游戏",
    "selectGameMobileTitle": "选择充值游戏",
    "selectGameParts": {
      "prefix": "选择您要",
      "keyword": "充值",
      "suffix": "的游戏"
    },
    "noRoleAccount": "您在此游戏内还没有角色账号，请先在游戏内创建角色后再进行购买。",
    "noRoleRefreshPrefix": "已创建账号？点击",
    "noRoleRefreshAction": "刷新",
    "noRoleRefreshing": "刷新中…",
    "noRoleRefreshNotFound": "未查询到角色信息",
    "noRoleRefreshFailed": "刷新失败，请稍后重试"
  },
  "login": {
    "agreeTerms": {
      "and": "和",
      "prefix": "我已阅读并同意",
      "privacy": "隐私政策",
      "terms": "服务条款"
    },
    "cancel": "取消",
    "bindGameGuide": "绑定游戏须知",
    "bindGameGuideContent": "打开任意一款Touka游戏，\n前往游戏内设置页面，绑定\n你的邮箱，即可享受特价商\n品优惠！",
    "captchaPlaceholder": "验证码",
    "invalidCaptcha": "请输入4位数字验证码",
    "email": "邮箱",
    "emailNotBound": "未检索成功,请输入游戏内绑定的邮箱哦~",
    "emailPlaceholder": "请输入您的电子邮箱",
    "keepLogin": "保持登录状态 15 天",
    "loading": "登录中...",
    "loginToStore": "登录Touka Store",
    "noAccount": "还没有账号?",
    "password": "密码",
    "passwordPlaceholder": "请输入密码",
    "submit": "登录",
    "title": "登录",
    "invalidEmail": "请输入有效的邮箱地址",
    "sendCodeFailed": "发送验证码失败",
    "resendCodePrompt": "请重新输入图形验证码以重新发送邮箱验证码"
  },
  "logout": {
    "cancel": "取消",
    "confirm": "确认",
    "dontRemind": "下次不再提醒",
    "failed": "退出登录失败，请稍后重试",
    "messageLine1": "退出登录后,近30天内所有设备的",
    "messageLine2": "登录状态将会失效。",
    "title": "温馨提示"
  },
  "menu": {
    "contactSupport": "联系客服",
    "gameList": "游戏列表",
    "myOrders": "我的订单"
  },
  "paymentSuccess": {
    "account": "账号:",
    "celebrationTitle": "购买成功",
    "confirm": "确定",
    "getPaymentInfoFailed": "获取支付信息失败",
    "loading": "加载中...",
    "orderDate": "订单日期:",
    "orderId": "订单号:",
    "paymentMethod": "付款方式:",
    "paypal": "PayPal",
    "price": "价格:",
    "purchaseContent": "购买内容:",
    "quantity": "购买数量:",
    "serverAndCharacter": "区组/角色:",
    "title": "感谢您的购买",
    "total": "全部:",
    "unionPay": "银联",
    "amountPaid": "实付金额:",
    "closeModal": "关闭"
  },
  "productModal": {
    "confirm": "确定",
    "purchaseDetails": "购买详情",
    "quantity": "数量:",
    "total": "全部:",
    "unitPrice": "单价:"
  },
  "products": {
    "giftPacks": "礼包",
    "diamond": "钻石",
    "products": "商品",
    "vouchers": "代金券",
    "toukaCoin": "Touka币",
    "toukaCoinBonusTip": "在TOUKA Store购物，享受额外10%的奖励！",
    "superValue": "超值",
    "limitShort": "限购",
    "remainingShort": "剩余时间",
    "giftPackLimitType": {
      "lifetime": "终身特惠",
      "weekly": "周特惠",
      "monthly": "月特惠"
    },
    "howToUseVouchers": "如何使用代金券？",
    "voucherGuide": {
      "title": "如何使用代金券？",
      "step1": "1.请在游戏内邮箱查收您购买的代金券。",
      "step2": "2.您可以在游戏商城标签页上方查看您的代金券数量。当您的代金券数量达到购买礼包需要的数量要求时，将优先使用代金券进行购买。",
      "backToProducts": "返回商品列表"
    },
    "luxuryVouchers": "豪华代金券"
  },
  "purchaseConfirm": {
    "card": "信用卡/借记卡",
    "confirm": "确认",
    "dontAskAgain": "30天内不再询问",
    "gameServer": "游戏区组",
    "paymentMethods": "支持的支付方式",
    "paypal": "PayPal",
    "title": "您确定通过此账户购买吗",
    "unionPay": "银联卡"
  },
  "serverSelect": {
    "characterLabel": "角色名称",
    "characterPlaceholder": "请选择角色",
    "confirm": "确定",
    "noResults": "暂无结果",
    "serverPlaceholder": "请输入区服名字进行搜索",
    "title": "选择游戏区组"
  },
  "support": {
    "cancel": "取消",
    "copied": "已复制",
    "copy": "一键复制",
    "description": "请与官方邮件反馈你的详细信息",
    "title": "客服支持"
  },
  "verification": {
    "back": "返回",
    "enterCode": "请输入验证码以继续",
    "incorrectCode": "验证码不正确",
    "invalidCode": "请输入6位验证码",
    "noCode": "收不到验证码?",
    "sentTo": "验证码已发送至",
    "submit": "提交",
    "submitting": "提交中..."
  }
} as const;
